import { useContext, useEffect } from 'react';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { DataContext } from 'entries/common/widgets/context';
import { useSearchRooms } from 'pages/common/hooks/use-search-rooms.hook';
import { activeRoomId, calculatedRoomsParams, roomsAtom } from 'pages/common/store/rooms';
import { setSelectedRoomIdIfNeeded } from '../helpers/set-selected-room-id-if-needed';
import { useIsFloorCalculator } from './use-is-floor-calculator.hook';

export const useGetRooms = () => {
  const data = useContext(DataContext);
  const apiMethods = data!.api;
  const calculatorId = data?.surfaces?.id || '';
  const isFloorCalculatorId = useIsFloorCalculator();
  const calculatedRoomParams = useRecoilValue(calculatedRoomsParams);
  const setSelectedRoomId = useSetRecoilState(activeRoomId);
  const calculatedRooms = useRecoilValue(roomsAtom);

  useSearchRooms({
    apiMethods,
    isFloor: isFloorCalculatorId,
    calculatorId,
  });

  useEffect(() => {
    setSelectedRoomIdIfNeeded({
      calculatedRooms,
      calculatedRoomParams,
      setSelectedRoomId,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps -- Специально убран calculatedRoomParams из зависимостей, т.к. его наличие вызывает лишний запуск эффекта
  }, [calculatedRooms, setSelectedRoomId]);
};
